import { ISectionThingsEveryParentShouldKnowProps } from "./variant.types";

export const sectionThingsEveryParentShouldKnowData: ISectionThingsEveryParentShouldKnowProps = {
  items: [
    {
      image: {
        src: "/images/landingPage/things-every-cat-parent-should-know/1.webp",
        width: 100,
        height: 100,
      },
      title: "Only 4% of the recipe needs to be meat.",
      body: "Legally, products named “with chicken” can contain as little as 4% chicken.",
    },
    {
      image: {
        src: "/images/landingPage/things-every-cat-parent-should-know/2.webp",
        width: 100,
        height: 100,
      },
      title: "What’s the rest? Unknown “meat derivatives”...",
      body: "It's a vague umbrella term that doesn’t specify the animal or body parts included in the recipe.",
    },
    {
      image: {
        src: "/images/landingPage/things-every-cat-parent-should-know/3.webp",
        width: 100,
        height: 100,
      },
      title: "Plus: grains, carbs and sugars.",
      body: "Many formulations contain plant-based fillers or carbs — but carnivore cats evolved to eat meat.",
    },
    {
      image: {
        src: "/images/landingPage/things-every-cat-parent-should-know/4.webp",
        width: 100,
        height: 100,
      },
      title: "Nutrition is sacrificed for shelf-life.",
      body: "Other brands cook with extreme temperatures. Which can negatively impact nutrients.",
    },
  ],
};
